'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _measurementsConnect = require('../components/measurements/measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

var _measurementsSelector = require('../components/measurements/measurementsSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


var SIZE_PADDING = 250;
var EMPTY_SIZE = { width: 0, height: 0 };

var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(state) {
    return {
        measurements: (0, _measurementsSelector.getMeasurementsMap)(state)
    };
};

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var canvasSizeDecorator = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec(_class = function (_React$Component) {
        _inherits(canvasSizeDecorator, _React$Component);

        function canvasSizeDecorator(props) {
            _classCallCheck(this, canvasSizeDecorator);

            var _this = _possibleConstructorReturn(this, (canvasSizeDecorator.__proto__ || Object.getPrototypeOf(canvasSizeDecorator)).call(this, props));

            _this.resetCanvasSize = function () {
                _this.canvasSize = EMPTY_SIZE;
            };

            _this.calculateCanvasSize = function (nextProps) {
                var canvasElementIds = nextProps.canvasElementIds,
                    measurements = nextProps.measurements;


                var newCanvasSize = measurements.reduce(function (size, measurement, id) {
                    if (!(0, _lodash.includes)(canvasElementIds, id)) return size;

                    size.width = Math.max(size.width, measurement.get('right'));
                    size.height = Math.max(size.height, measurement.get('bottom'));
                    return size;
                }, { width: 0, height: 0 });

                var sizePixels = {
                    width: Math.max(_this.canvasSize.width, newCanvasSize.width + SIZE_PADDING),
                    height: Math.max(_this.canvasSize.height, newCanvasSize.height + SIZE_PADDING)
                };

                _this.canvasSize = sizePixels;
                _this.setState({ canvasSize: sizePixels });
            };

            _this.debouncedCalculateCanvasSize = (0, _lodash.debounce)(_this.calculateCanvasSize, 64);


            _this.canvasSize = EMPTY_SIZE;
            _this.state = {
                canvasSize: EMPTY_SIZE
            };
            return _this;
        }

        _createClass(canvasSizeDecorator, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var measurements = nextProps.measurements,
                    currentBoardId = nextProps.currentBoardId;


                if (currentBoardId !== this.props.currentBoardId) this.resetCanvasSize();

                if (measurements === this.props.measurements) return;

                this.debouncedCalculateCanvasSize(nextProps);
            }
        }, {
            key: 'render',
            value: function render() {
                var canvasSize = this.state.canvasSize;

                var _props = this.props,
                    measurements = _props.measurements,
                    rest = _objectWithoutProperties(_props, ['measurements']); // eslint-disable-line no-unused-vars

                return _react2.default.createElement(DecoratedComponent, _extends({ canvasSize: canvasSize }, rest));
            }
        }]);

        return canvasSizeDecorator;
    }(_react2.default.Component)) || _class);


    canvasSizeDecorator.propTypes = {
        canvasElementIds: _propTypes2.default.array,
        measurements: _propTypes2.default.object,
        currentBoardId: _propTypes2.default.string
    };

    return canvasSizeDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/canvasSizeDecorator.js
// module id = 1689
// module chunks = 0